import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews, getCategoryName } from "@/utils/news";

interface NewsCardProps {
  item: NewsItem;
  layout?: "horizontal" | "vertical";
}

export default function NewsCard({ item, layout = "horizontal" }: NewsCardProps) {
  const isVertical = layout === "vertical";

  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-500/70">
      <Link
        to={`/detail/${item.id}`}
        className={`flex h-full ${
          isVertical ? "flex-col" : "flex-col sm:flex-row"
        }`}
      >
        <div
          className={`relative shrink-0 overflow-hidden ${
            isVertical ? "h-44 w-full" : "h-44 w-full sm:h-auto sm:w-56"
          }`}
        >
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - 911爆料`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          {item.exclusive && (
            <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-1 font-label text-[11px] font-bold tracking-wide text-background-50">
              独家
            </span>
          )}
        </div>

        <div className="flex flex-1 flex-col p-4 md:p-5">
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span className="rounded-md bg-primary-100 px-2 py-0.5 font-medium text-primary-800">
              {getCategoryName(item.category)}
            </span>
            <span className="text-foreground-500">{item.source}</span>
          </div>

          <h3
            className={`mt-2.5 font-heading font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 ${
              isVertical ? "text-base" : "text-base md:text-lg"
            }`}
          >
            {item.title}
          </h3>

          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {item.summary}
          </p>

          <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1.5 pt-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {item.publishedAt}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {formatViews(item.views)}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}